import { render, staticRenderFns } from "./connection-error.vue?vue&type=template&id=6f484882"
import script from "./connection-error.vue?vue&type=script&lang=js"
export * from "./connection-error.vue?vue&type=script&lang=js"
import style0 from "./connection-error.vue?vue&type=style&index=0&id=6f484882&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports